export interface IconDefinition {
  name: string;
  src: string;
}

import invoiceDollarSvg from './invoice-dollar.svg';

export const ICON_DEFINITIONS: Record<string, IconDefinition> = {
  InvoiceDollar: {
    name: 'InvoiceDollar',
    src: invoiceDollarSvg,
  },
  // Add more icons following the same pattern:
  // AnotherIcon: {
  //   name: 'AnotherIcon',
  //   src: anotherIconSvg,
  // },
};
